<template>
    <g fill="none" fill-rule="evenodd">
        <g fill-rule="nonzero">
            <g>
                <path fill="#C2CDD7" d="M9.363 3.938c0-.394-.158-2.363-2.363-2.363S4.638 3.544 4.638 3.937v3.938H3.063V3.937C3.063 2.6 3.85 0 7 0s3.938 2.599 3.938 3.938H9.363z" transform="translate(-623 -430) translate(623 430)"/>
                <path fill="#C2CDD7" d="M12.425 17H1.575C.7 17 0 16.333 0 15.5v-7C0 7.667.7 7 1.575 7h10.85C13.3 7 14 7.667 14 8.5v7c0 .833-.7 1.5-1.575 1.5" transform="translate(-623 -430) translate(623 430)"/>
                <path fill="#FFF" d="M9 12c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2" transform="translate(-623 -430) translate(623 430)"/>
            </g>
        </g>
    </g>
</template>

<script>
export default {
    name: 'unlockAppIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 14 17');
    }
};
</script>
